import { Typography, makeStyles } from '@material-ui/core';
import React from 'react';

type Props = {
  displayMessage: string;
};

export const ReadOnlyStatusText: React.FC<Props> = ({ displayMessage }) => {
  const classes = useStyles();
  return (
    <Typography variant="h3" noWrap className={classes.text}>
      {displayMessage}
    </Typography>
  );
};

const useStyles = makeStyles(() => ({
  text: {
    textAlign: 'center',
    textTransform: 'uppercase',
    color: 'inherit',
  },
}));
